/// <amd-dependency path="jqueryplugins"/>
/// <amd-dependency path="knockoutplugins"/>
/// <amd-dependency path="modules"/>
/// <amd-dependency path="kendo"/>
define(["require", "exports", "jquery", "./utils/tools", "jqueryplugins", "knockoutplugins", "modules", "kendo"], function (require, exports, $, tools) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    console.log("Index - ALL MODULES LOADED");
    $(function () {
        $.ajaxSetup({
            complete: function (xhr) {
                if (xhr.responseJSON && xhr.responseJSON.Error === "SessionExpired") {
                    //var currentUrl = window.location.pathname;
                    window.location.href = "/Account/LogOff?LogOff=autoLogOff";
                }
                if (xhr.responseJSON && xhr.responseJSON.Error === "Forbidden") {
                    tools.error("You don't have permissions to view this content");
                }
                if (xhr.responseJSON && xhr.responseJSON.Error && !xhr.responseJSON.Success) {
                    tools.error(xhr.responseJSON.Error);
                }
            },
            error: function (data) {
                console.log("failed", data);
            }
        });
    });
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./build/index.js
// module id = 97
// module chunks = 1